var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEvReRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 113 113",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_82",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 82",
    x1: 48.41,
    y1: 7.19,
    x2: 63.93,
    y2: 83.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eef2f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#f6f8fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m36.45,97.66c-2.89-2.36-6.33-3.87-9.96-4.73-9.35-2.2-16.32-10.61-16.32-20.61V22C10.16,10.3,19.64.82,31.34.82h50.33c11.69,0,21.17,9.48,21.17,21.17v50.33c0,10.01-6.98,18.41-16.32,20.61-3.63.85-7.07,2.37-9.96,4.73l-16.09,13.11c-2.31,1.88-5.61,1.88-7.92,0l-16.09-13.11Z",
    fill: "#a2eaa0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.51,10.2h50.15c6.51,0,11.8,5.29,11.8,11.8v50.33c0,6.51-5.29,11.8-11.8,11.8H31.34c-6.51,0-11.8-5.29-11.8-11.8V22.17c0-6.61,5.37-11.97,11.97-11.97Z",
    fill: "url(#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_82)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "evre_logo",
    "data-name": "evre logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6908",
    "data-name": "Path 6908",
    d: "m56.82,41.77c0-.2.03-.41.08-.6.1-.47.48-.83.95-.9.19-.04.38-.06.58-.06h4.57c.4,0,.81.03,1.21.08.48.06.95.2,1.37.43.67.35,1.19.93,1.47,1.63.17.44.26.9.26,1.37,0,.45-.06.9-.2,1.33-.19.56-.55,1.04-1.03,1.38-.48.35-1.03.6-1.6.75l-.4.1c.05.05.11.08.17.11.39.26.75.56,1.07.91.6.68,1.12,1.43,1.54,2.24.24.43.44.88.6,1.35.04.11.07.23.09.35.01.12,0,.23-.05.34-.15.4-.52.68-.94.74-.25.04-.5.02-.74-.06-.14-.05-.26-.12-.37-.22-.19-.17-.36-.36-.5-.58-.61-.96-1.17-1.95-1.77-2.92-.27-.47-.59-.9-.96-1.29-.36-.37-.85-.6-1.37-.65-.44-.05-.88-.01-1.32-.03-.07,0-.09.03-.09.09,0,.04,0,.08,0,.11v3.97c0,.26-.04.52-.13.77-.14.42-.51.72-.94.77-.25.04-.51.02-.75-.07-.35-.14-.62-.44-.71-.81-.06-.21-.09-.44-.09-.66.04-.04.02-.09.02-.13v-9.75s.02-.09-.02-.13Zm2.63,2.17v1.66c0,.13,0,.13.12.13.9,0,1.8.03,2.69-.02.28-.01.56-.04.84-.09.35-.05.69-.18.98-.38.26-.19.44-.46.51-.77.05-.23.07-.47.05-.71,0-.18-.04-.35-.11-.51-.23-.56-.75-.95-1.35-1.01-.46-.06-.91-.09-1.37-.09h-2.3c-.07,0-.09.03-.09.09,0,.03,0,.07,0,.1l.02,1.6Z",
    fill: "#a2eaa0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6909",
    "data-name": "Path 6909",
    d: "m69.79,46.68v-4.89c0-.24.04-.48.11-.71.11-.39.42-.69.81-.77.21-.06.43-.08.65-.09h6.95c.2,0,.39.03.58.09.33.11.57.39.61.74.03.16.02.32-.03.48-.08.29-.3.52-.58.61-.18.06-.37.09-.56.09h-5.78q-.14,0-.14.14v2.93c0,.07.02.11.09.1.04,0,.08,0,.11,0h5.2c.19,0,.38.03.56.09.37.11.63.45.63.84.01.19-.03.37-.11.54-.1.19-.27.33-.47.41-.2.07-.41.1-.61.1h-5.17c-.26,0-.22-.03-.22.23v3.25c0,.21-.02.19.19.19h5.87c.22,0,.44.03.64.11.36.13.6.47.61.85.02.22-.03.44-.13.63-.18.27-.47.45-.8.47-.21.02-.43.03-.64.02h-6.71c-.2,0-.41-.02-.61-.06-.51-.06-.91-.46-.99-.96-.04-.19-.06-.38-.06-.58v-4.84Z",
    fill: "#a2eaa0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6910",
    "data-name": "Path 6910",
    d: "m32.44,46.68v-4.89c0-.22.02-.44.07-.65.11-.46.49-.8.95-.86.19-.04.39-.06.59-.06h6.87c.16,0,.31.02.47.05.46.08.8.5.77.97,0,.34-.18.65-.47.81-.17.1-.37.15-.57.16h-5.97c-.12,0-.12,0-.12.13v2.94q0,.13.14.13h5.3c.15,0,.3.02.45.06.32.06.59.3.68.62.18.5-.07,1.05-.56,1.23-.08.03-.16.05-.24.06-.16.02-.31.03-.47.03h-5.1c-.2,0-.18-.02-.18.18v3.35q0,.12.13.12h5.97c.25,0,.5.05.73.16.26.14.45.39.49.69.04.21.02.42-.06.61-.11.27-.33.47-.61.55-.16.05-.33.07-.49.07h-7.22c-.26,0-.53-.05-.77-.14-.3-.11-.54-.34-.64-.65-.08-.23-.12-.48-.11-.73v-4.92Z",
    fill: "#a2eaa0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6911",
    "data-name": "Path 6911",
    d: "m49.27,50.32c.06-.03.05-.08.07-.12l1.01-3c.45-1.33.89-2.66,1.34-3.99.22-.66.45-1.33.67-1.99.06-.16.11-.33.18-.48.13-.35.42-.61.77-.7.62-.16,1.27.17,1.5.77.07.22.09.45.04.67-.06.29-.14.58-.26.85-.21.59-.43,1.19-.65,1.78l-.79,2.11c-.21.57-.42,1.14-.63,1.71-.29.78-.59,1.58-.88,2.35-.16.44-.32.88-.48,1.32-.12.37-.29.71-.51,1.03-.27.39-.69.64-1.16.69-.28.04-.56.02-.83-.05-.41-.11-.76-.38-.98-.75-.17-.3-.32-.62-.43-.95-.38-1.03-.75-2.06-1.13-3.09-.29-.8-.58-1.6-.87-2.39-.35-.95-.7-1.9-1.05-2.85-.15-.42-.3-.83-.44-1.25-.09-.26-.15-.53-.16-.8,0-.12.01-.23.05-.34.15-.44.52-.76.98-.84.19-.03.38-.02.57.01.31.06.58.27.71.56.17.33.31.68.42,1.03l1.15,3.39.81,2.4c.29.86.58,1.71.86,2.56.04.12.08.23.12.36Z",
    fill: "#a2eaa0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6912",
    "data-name": "Path 6912",
    d: "m56.82,41.77s.02.09.02.13v9.75s.02.1-.02.13c-.04-.04-.03-.09-.03-.13v-9.75s-.02-.09.03-.13Z",
    fill: "#a2eaa0"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 13,
    r: 10,
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 13,
    r: 7,
    fill: "#f43131"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvReRed);
export default __webpack_public_path__ + "static/media/EVRe_red.d0e86643b0879f97fd146055e49f89fd.svg";
export { ForwardRef as ReactComponent };